import React, { useState } from "react";
import { Rating, Button, Card, CardContent, Typography, TextField } from "@mui/material";

export default function FeedBackWithRating() {
    const [ratings, setRatings] = useState({
        driverPoliteness: 0,
        driverRouteFlexibility: 0,
        driverBehavior: 0,
        driverSafety: 0,
        driverFairCharges: 0,
        vehicleCondition: 0,
        vehicleReliability: 0,
        vehicleSafety: 0,
        appEaseOfUse: 0,
        appAccuracy: 0,
        appUpdates: 0,
        overall_rate:0
      });
    
    
      const handleRatingChange = (key, value) => {
        setRatings((prev) => ({ ...prev, [key]: value }));
      };
    
      const handleCommentChange = (event) => {
        setRatings((prev) => ({ ...prev, additionalComments: event.target.value }));
      };
      const handleSubmit = async () => {
        try {
          const response = await fetch("https://your-backend-api.com/feedback", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(ratings),
          });
          if (response.ok) {
            alert("Feedback submitted successfully!");
          } else {
            alert("Failed to submit feedback.");
          }
        } catch (error) {
          console.error("Error submitting feedback:", error);
          alert("Something went wrong!");
        }
      };
    
      return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
          <Card className="w-full max-w-3xl p-6 shadow-lg rounded-xl">
            <CardContent>
              <Typography variant="h4" className="text-center mb-4 font-bold">
                Rate Your Trip
              </Typography>
              
              {/* DRIVER FEEDBACK */}
              <Typography variant="h5" className="mt-4 font-semibold">Driver Feedback</Typography>
              {[
                ["driverPoliteness", "Politeness & Professionalism", "Was the driver courteous and professional?"],
                ["driverRouteFlexibility", "Route Flexibility", "Was the driver accommodating with route preferences?"],
                ["driverBehavior", "Behavior & Attitude", "Did the driver maintain a friendly and respectful attitude?"],
                ["driverSafety", "Safe Driving", "Did the driver follow traffic rules and drive safely?"],
                ["driverFairCharges", "Fair Charges", "Did the driver accept the fare without demanding extra tips?"],
              ].map(([key, title, subtitle]) => (
                <div key={key} className="my-3">
                  <Typography variant="h6">{title}</Typography>
                  <Typography variant="body2" className="text-gray-600">{subtitle}</Typography>
                  <Rating
                    name={key}
                    value={ratings[key]}
                    onChange={(_, value) => handleRatingChange(key, value)}
                    precision={0.5}
                    size="large"
                  />
                </div>
              ))}
              
              {/* VEHICLE FEEDBACK */}
              <Typography variant="h5" className="mt-6 font-semibold">Vehicle Feedback</Typography>
              {[
                ["vehicleCondition", "Vehicle Condition", "Was the vehicle clean and well-maintained?"],
                ["vehicleReliability", "Reliability", "Did the vehicle perform smoothly without issues?"],
                ["vehicleSafety", "Safety", "Was the ride free from any accidents or breakdowns?"],
              ].map(([key, title, subtitle]) => (
                <div key={key} className="my-3">
                  <Typography variant="h6">{title}</Typography>
                  <Typography variant="body2" className="text-gray-600">{subtitle}</Typography>
                  <Rating
                    name={key}
                    value={ratings[key]}
                    onChange={(_, value) => handleRatingChange(key, value)}
                    precision={0.5}
                         size="large"
                  />
                </div>
              ))}
    
              {/* APPLICATION FEEDBACK */}
              <Typography variant="h5" className="mt-6 font-semibold">Application Feedback</Typography>
              {[
                ["appEaseOfUse", "Ease of Use", "Was the app user-friendly and easy to navigate?"],
                ["appAccuracy", "Accuracy & Reliability", "Was the app accurate in booking and trip details?"],
                ["appUpdates", "Seamless Updates", "Did the app function smoothly after updates?"],
              ].map(([key, title, subtitle]) => (
                <div key={key} className="my-3">
                  <Typography variant="h6">{title}</Typography>
                  <Typography variant="body2" className="text-gray-600">{subtitle}</Typography>
                  <Rating
                    name={key}
                    value={ratings[key]}
                    onChange={(_, value) => handleRatingChange(key, value)}
                    precision={0.5}
                         size="large"
                  />
                </div>
              ))}
              
              <Typography variant="h5" className="mt-6 font-semibold">Additional Comments</Typography>
              <TextField
                fullWidth
                multiline
                rows={4}
                placeholder="Write any additional comments here..."
                variant="outlined"
                value={ratings.additionalComments}
                onChange={handleCommentChange}
                className="mt-2"
              />
              {/* SUBMIT BUTTON */}
              <div className="flex justify-center mt-6">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  className="px-6 py-2 rounded-lg"
                >
                  Submit Feedback
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }
    
